(() => {
  const bind = (track) => {
    if (track.dataset.rdDragBound === 'true') return;
    track.dataset.rdDragBound = 'true';

    let startX = 0;
    let startScroll = 0;
    let dragged = false;
    let activePointerId = null;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0 || activePointerId !== null) return;
      activePointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragged = false;
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', stop);
      window.addEventListener('pointercancel', stop);
    });

    const move = (event) => {
      if (event.pointerId !== activePointerId) return;
      const distance = event.clientX - startX;
      if (!dragged) {
        if (Math.abs(distance) <= 4) return;
        dragged = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
      track.scrollLeft = startScroll - distance;
    };

    const stop = (event) => {
      if (event.pointerId !== activePointerId) return;
      activePointerId = null;
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      track.classList.remove('is-dragging');
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', stop);
      window.removeEventListener('pointercancel', stop);
      if (event.type === 'pointercancel') dragged = false;
    };

    track.addEventListener('dragstart', (event) => {
      if (activePointerId !== null) event.preventDefault();
    });
    track.addEventListener('click', (event) => {
      if (!dragged || event.detail === 0) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);
  };

  const bindControls = (track) => {
    const section = track.closest('.rd-section');
    const controls = [...(section?.querySelectorAll('[data-rd-slider-controls]') || [])]
      .find((candidate) => candidate.dataset.rdSliderControls === track.id);
    if (!controls || controls.dataset.rdBound === 'true') return;
    controls.dataset.rdBound = 'true';
    const buttons = [...controls.querySelectorAll('[data-rd-slider-step]')];
    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.abs(track.scrollLeft);
      buttons.forEach((button) => {
        button.disabled = Number(button.dataset.rdSliderStep) < 0 ? position <= 1 : position >= max - 1;
      });
      controls.hidden = max <= 1;
    };
    controls.addEventListener('click', (event) => {
      const button = event.target.closest('[data-rd-slider-step]');
      if (!button || button.disabled) return;
      const style = getComputedStyle(track);
      const card = track.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0) : track.clientWidth;
      track.scrollBy({
        left: Number(button.dataset.rdSliderStep) * step * (style.direction === 'rtl' ? -1 : 1),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    [...track.children].forEach((card) => observer.observe(card));
    const unload = (event) => {
      if (!event.target.contains(track)) return;
      observer.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    update();
  };

  const bindTouchPreview = (link) => {
    if (link.dataset.rdTouchBound === 'true' || !link.querySelector('.rd-product-card__image--alternative')) return;
    link.dataset.rdTouchBound = 'true';
    let pointerId = null;
    const reset = (event) => {
      if (event.pointerId !== pointerId) return;
      pointerId = null;
      link.classList.remove('is-touch-preview');
      window.removeEventListener('pointerup', reset);
      window.removeEventListener('pointercancel', reset);
    };
    link.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch' || pointerId !== null) return;
      pointerId = event.pointerId;
      link.classList.add('is-touch-preview');
      window.addEventListener('pointerup', reset);
      window.addEventListener('pointercancel', reset);
    }, { passive: true });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-rd-drag-scroll]').forEach(bind);
    root.querySelectorAll('[data-rd-drag-scroll]').forEach(bindControls);
    root.querySelectorAll('.rd-product-card__link').forEach(bindTouchPreview);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
